import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { PublicationService } from 'app/services/publication.service';
import { AuthenticationService } from 'app/services/authentication.service';

@Injectable({
	providedIn: 'root',
})
export class PublicationFieldGuard implements CanActivate {

	constructor(private publicationService: PublicationService, private authenticationService: AuthenticationService) { }

	// checks if the publication has the extraPlayoutField passed in data.publicationField (string) or user has root access
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (next && next.data && next.data.publicationField) {
			const hasField = this.publicationService.hasPublicationField(next.data.publicationField);
			if (hasField) {
				return of(true);
			}
			// else: check root user (consistent with behaviour of hasPublicationField Directive)
			return this.authenticationService.hasPermission('root');
		} else {
			return of(false);
		}
	}
}
